import { css as emotionCSS } from '@emotion/react';
import { CircularProgress as CircularProgress, CircularProgressProps } from '@mildang/mui';

const rootStyle = emotionCSS`
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  padding: 20px;
`;

export interface DataProgressProps {
  className?: string;
  CircularProgressProps?: CircularProgressProps;
}

const DataProgress = (props: DataProgressProps) => {
  return (
    <div css={rootStyle} className={props.className}>
      <CircularProgress color="secondary" {...props.CircularProgressProps} />
    </div>
  );
};

export default DataProgress;
